export { default } from "./Tabs.js";
